
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

/**
 * Main application entry point with error handling
 * This ensures we have proper error reporting if the root element doesn't exist
 */
try {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }
  
  createRoot(rootElement).render(<App />);
} catch (error) {
  console.error("Failed to render application:", error);
  
  // Create fallback UI if rendering fails
  const errorElement = document.createElement('div');
  errorElement.style.padding = '20px';
  errorElement.style.margin = '20px';
  errorElement.style.backgroundColor = '#fff0f0';
  errorElement.style.border = '1px solid #ff0000';
  errorElement.style.borderRadius = '4px';
  
  errorElement.innerHTML = `
    <h2>Application Error</h2>
    <p>Sorry, the application failed to load. Please refresh the page or contact support.</p>
    <pre>${error instanceof Error ? error.message : 'Unknown error'}</pre>
  `;
  
  document.body.appendChild(errorElement);
}
